module.exports = __webpack_public_path__ + "static/breaker-58c3b5fd683ca02d97605b5fb16fc73c.png";